import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import ProductCard from '../components/ProductCard';
import SeoHead from '../components/seo/SeoHead';
import grid from '../components/home/FeaturedProducts.module.css';

interface Product {
  id: string;
  name: string;
  price: number;
  old_price?: number;
  image_url?: string;
  slug: string;
  short_description?: string;
  description?: string;
}

const AllProducts: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data, error } = await supabase
          .from('products')
          .select('id, name, price, old_price, image_url, slug, short_description')
          .eq('is_active', true)
          .order('name', { ascending: true });
        if (error) throw error;
        setProducts(data || []);
      } catch (err) {
        console.error('Error loading products:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 20px' }}>
      <SeoHead
        title="Svi proizvodi"
        description="Pogledaj sve saksije, žardinjere i pribor u ponudi."
        type="website"
      />
      <h1 style={{ marginBottom: 6 }}>Svi proizvodi</h1>
      <p style={{ color: '#6b7280', marginTop: 0, marginBottom: 24 }}>
        {loading ? 'Učitavanje...' : `${products.length} proizvoda u ponudi`}
      </p>

      {loading ? (
        <p style={{ minHeight: '100vh' }}>Učitavanje proizvoda...</p>
      ) : products.length === 0 ? (
        <p>Trenutno nema proizvoda.</p>
      ) : (
        <div className={grid.productsGrid}>
          {products.map((product, idx) => (
            <ProductCard key={product.id} product={product} index={idx} />
          ))}
        </div>
      )}
    </div>
  );
};

export default AllProducts;
